'use strict';

export default function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}



//////////////////
// WEBPACK FOOTER
// E:/项目/渠道推广统计/statisticsLizu/node_modules/axios/lib/helpers/bind.js
// module id = if9n
// module chunks = 0